
import React from 'react';
import { Load } from '../types';
import { Zone } from '../data/zoneData';
import ZoneCard from './ZoneCard';

interface ZoneGridProps {
  zones: Zone[];
  loads: Load[];
  selectedZone: string | null;
  onZoneSelect: (zoneId: string) => void;
  handleToggleStatus: (id: string) => void;
  openScheduling: (load: Load) => void;
}

const ZoneGrid: React.FC<ZoneGridProps> = ({ 
  zones, 
  loads, 
  selectedZone,
  onZoneSelect,
  handleToggleStatus,
  openScheduling
}) => {
  const getZoneLoad = (zone: Zone) => {
    if (!zone.loadId) return null;
    return loads.find(load => load.id === zone.loadId) || null;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {zones.map(zone => {
        const load = getZoneLoad(zone);
        
        return (
          <ZoneCard
            key={zone.id}
            zoneName={zone.name}
            zoneId={zone.id}
            load={load}
            isSelected={selectedZone === zone.id}
            onSelect={onZoneSelect}
            onToggleStatus={handleToggleStatus}
            onSchedule={openScheduling}
          />
        );
      })}
    </div>
  );
};

export default ZoneGrid;
